import React, { useState } from "react";

const videoPlaylist = [
    "1.mp4",
    "3.mp4",
    "4.mp4"
];

const publicUrl = window.myLocalizedData ? window.myLocalizedData.PUBLIC_URL : "";

export const HeroVideoCarousel = () => {
    const [current, setCurrent] = useState(0);

    const onEnded = () => {
        setCurrent((prev) => {
            if (prev === videoPlaylist.length - 1) {
                return 0;
            }
            return prev + 1;
        });
    };

    return (
        <div className="hero-video-wrapper">
            <div className="hero-content">
                <h1>Supportive Therapy for Every Step of Your Journey.</h1>
                <p>Life skills and strategies to help you Elevate, Evolve, and Excel to your best self!</p>
                <div className="hero-actions">
                    <a href="#provider" className="cta-button">Meet Your Provider</a>
                    <a href="#contact" className="secondary-button">Get in Touch</a>
                </div>
            </div>
            <video
                key={current} // 💡 This forces reloading of the <video> element when "current" changes
                autoPlay
                muted
                playsInline
                id="background-video"
                onEnded={onEnded}
                onClick={onEnded}
            >
                <source
                    src={`${publicUrl}/herovideos/${videoPlaylist[current]}`}
                    type="video/mp4"
                    id="video-source"
                />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};
